import { createContext, useState } from "react";
import { parseFarmerProfile } from "@helpers/readFarmerProfile";

const profileContext = createContext({});

export const ProfileProvider = ({ children }) => {
  const [farmerProfile, setFarmerProfile] = useState(parseFarmerProfile());

  const profileAction = (data) => {
    setFarmerProfile(data);
  };
  const resetProfileContext = () => {
    setFarmerProfile(null);
  };

  return (
    <profileContext.Provider
      value={{ farmerProfile, profileAction, resetProfileContext }}
    >
      {children}
    </profileContext.Provider>
  );
};

export default profileContext;
